import { DesignTokens } from "../../types"

export const colors: DesignTokens.Colors = {
  transparent: "transparent",
  current: "currentColor",
  inherit: "inherit",
  black: "#333333",
  white: "#FFFFFF",

  whiteAlpha60: "rgba(255, 255, 255, 0.6)",

  blackAlpha60: {
    100: "rgba(0, 0, 0, 0.06)",
    700: "rgba(0, 0, 0, 0.64)",
  },

  gray050: "#F6F7F8",
  gray100: "#E6E7E8",
  gray200: "#D5D8DB",
  gray400: "#A5A8AB",
  gray600: "#707174",

  green050: "#EAFCDE",
  green200: "#A9D18C",
  green400: "#53A318",
  green600: "#318200",

  blue050: "#E8F8FF",
  blue200: "#B8E8FF",
  blue400: "#2999F5",
  blue600: "#0070CC",

  red050: "#FFF1F4",
  red600: "#E00038",

  yellow050: "#FFF9EA",
  yellow600: "#FFC120",

  purple600: "#6650d7",
}
